/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Flex, If } from '@cleartax/zoids';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { IRNComplianceSummary } from '../../../common/types';

import { BLACK_ARROW } from '../../../constants/urls';
import { useGlobalState } from '../../context/qrState';
import { formatMISCardDetails } from  '../../utils/formatInvoices';
import {
  MisChildCard,
  MisChildHeaderDiv,
  MisChildSummaryDiv,
  MisChildCardSummaryBox,
  CardLabel,
  CardLabelText,
  MISChildCardGstinText,
  MISChildCardBranchText,
  MisChildCardSummaryValue,
} from './styles';

interface MisChildCardProps {
  childCardData: IRNComplianceSummary;
}

const MISChildCard: React.FC<MisChildCardProps> = ({ childCardData }) => {
  const [complianceOrgID,setComplianceOrgID]=useGlobalState("complianceCardOrgID");
  const [pageNumber, setPageNumber] = useGlobalState('pageNumber');
  const [complianceListHeader,setComplianceListHeader]= useGlobalState('complianceINVListHeader');
  const history= useHistory();
  const branchName = childCardData.branchOrgName
    ? childCardData.branchOrgName
    : childCardData.gstin;
  let showingGSTIN = true;

  if(childCardData.branchOrgName){
    showingGSTIN = true;
  }else{
    showingGSTIN = false;
  }

  const complianceCardClick=()=>{
    setPageNumber(0);
    
    const tempData = {
      branchName,
      gstinOrgName:childCardData.gstinOrgName,
      gstin:childCardData.gstin,
    }
    setComplianceListHeader(tempData);
    localStorage.setItem("HEADER_DATA",JSON.stringify(tempData));
    
    if(childCardData.orgId){
      setComplianceOrgID(childCardData.orgId);
      localStorage.setItem("COMPLIANCE_ID",childCardData.orgId);
    }else{
      setComplianceOrgID('NOT_FOUND');
      localStorage.setItem("COMPLIANCE_ID",'NOT_FOUND')
    }
    history.push('/invcompliance');
  }
 
  return (
    <MisChildCard>
      <MisChildHeaderDiv>
        <Flex flexDirection='column' alignItems='flex-start' justifyContent='space-between' width="90%">
          <MISChildCardBranchText>
            <span style={{ overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis",width:"100%" }}>
              {branchName}
            </span>
          </MISChildCardBranchText>
          <MISChildCardGstinText>
            <If condition={showingGSTIN === true}>
              <span style={{ overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis",width:"100%" }}>
                {childCardData.gstinOrgName} | GSTIN: {childCardData.gstin}
              </span>
            </If>
            <If condition={showingGSTIN === false}>
              <span style={{ overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis",width:"100%" }}>
                {childCardData.gstinOrgName}
              </span>
            </If>
          </MISChildCardGstinText>
          </Flex>
        <img src={BLACK_ARROW} alt="" width="48px" height="48px" onClick={complianceCardClick}/>
      </MisChildHeaderDiv>
      <MisChildSummaryDiv>
        <MisChildCardSummaryBox>
          <MisChildCardSummaryValue>
            {' '}
            { formatMISCardDetails(
              childCardData.irnSummaryDetails.totalIrnGenerated
            )}
          </MisChildCardSummaryValue>
          <CardLabel color="#DDFBE2" backgroundColor="#50CD65">
            <CardLabelText>generated</CardLabelText>
          </CardLabel>
        </MisChildCardSummaryBox>
        <MisChildCardSummaryBox>
          <MisChildCardSummaryValue color="#454ADE">
            {' '}
            { formatMISCardDetails(
              childCardData.irnSummaryDetails.totalPendingIrnGeneration
            )}
          </MisChildCardSummaryValue>
          <CardLabel color="#FFF7CE"backgroundColor="#EECE33">
            <CardLabelText color="12422E">Not Generated</CardLabelText>
          </CardLabel>
        </MisChildCardSummaryBox>
        <MisChildCardSummaryBox>
          <MisChildCardSummaryValue>
            {' '}
            { formatMISCardDetails(
              childCardData.irnSummaryDetails.totalIrnCancelled
              )}
          </MisChildCardSummaryValue>
          <CardLabel color="#FFE5D4" backgroundColor="#FE9D54">
            <CardLabelText color="#732A00">cancelled</CardLabelText>
          </CardLabel>
        </MisChildCardSummaryBox>
        <MisChildCardSummaryBox>
          <MisChildCardSummaryValue>
            { formatMISCardDetails(
              childCardData.irnSummaryDetails.totalIrnFailed
            )}
          </MisChildCardSummaryValue>
          <CardLabel color="#FFD7D5" backgroundColor="#FF685F">
            <CardLabelText color="#732A00">failed</CardLabelText>
          </CardLabel>
        </MisChildCardSummaryBox>
      </MisChildSummaryDiv>
    </MisChildCard>
  );
};
export default MISChildCard;
